__turbopack_context__.v({
  "truck": "_48dLeq_truck",
  "truckDrive": "_48dLeq_truckDrive",
});
